import { fetchQuery } from '@/services/messaging/fetchQuery';

export function getLicenseOverview(customerId, ppwRecId, licenseId) {
  return fetchQuery("GetLicenseOverview", {
    customerId,
    ppwRecId,
    licenseId
  });
}
